
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13252',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13252",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.801",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9965",
  "foundations-components": "static-1.8505",
  "foundations-components-legacy": "static-1.1530",
  "foundations-theming": "static-1.4786",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8342",
  "hub-http-shared-msw-handlers": "static-1.10629",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11799",
  "I18n": "static-7.1674",
  "jasmine-runner": "static-1.6761",
  "marketplace-discovery-studio-lib": "static-1.645",
  "marketplace-storefront-base": "static-1.13315",
  "quartz": "static-1.7466",
  "react-dlb": "static-1.89",
  "react-rhumb": "static-1.17032",
  "reactive-variable-buffer-atom": "static-1.3166",
  "reporting-testing-lib": "static-1.10776",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12835",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7637",
  "ui-addon-i18n": "static-1.11457",
  "ui-addon-react-router-dom": "static-1.9845",
  "unified-auth": "static-1.932",
  "unified-auth-core-lib": "static-1.1214",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8411",
  "hub-http": "static-1.6523",
  "integrations-lib": "static-1.17052",
  "marketplace-ui-common": "static-1.20746",
  "marketplace-ui-install": "static-1.732",
  "property-management-iframe": "static-1.14143",
  "quartz-config": "static-1.1244",
  "quartz-core": "static-1.6685",
  "quartz-routing": "static-1.896",
  "quick-fetch": "static-1.4134",
  "react": "static-7.196",
  "rpc-client-utils": "static-1.4976",
  "ts-schema": "static-1.4299",
  "ui-universal-auth": "static-1.9418",
  "UIComponents": "static-3.8745",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3626",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3743",
  "quartz-webpack": "static-1.3690",
  "bend-plugin-quartz-routing": "static-1.544",
  "ai-components-ui-library": "static-1.9730",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5195",
  "pulse": "static-1.940",
  "react-codemirror": "static-1.10950",
  "ui-extensions-preview-lib": "static-1.621",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4774",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2502",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9734",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.71",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5561",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.502",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2660",
  "ui-fonts": "static-1.1061",
  "ui-images": "static-2.1250",
  "bend-plugin-foundations-theming": "static-1.3269",
  "foundations-theming-base": "static-1.3771",
  "stylex": "static-1.41",
  "HeadJS": "static-2.798",
  "hs-test-utils-bend-plugin": "static-1.3453",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4623",
  "ui-addon-video-player": "static-1.9013",
  "ai-rendering-library": "static-1.11108",
  "chirp-fetch": "static-1.2204",
  "connections-embed-lib": "static-1.1521",
  "copilot-toolkit": "static-1.11856",
  "feedback-loader": "static-1.29821",
  "laboratory-lib": "static-3.7462",
  "marketplace-embed": "static-1.22928",
  "marketplace-ui-details": "static-1.10641",
  "marketplace-ui-reviews": "static-1.20701",
  "marketplace-ui-tracking": "static-1.14916",
  "sanitize-text": "static-1.8465",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7205",
  "quartz-head": "static-1.1131",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4966",
  "immer": "static-1.101",
  "immerable": "static-1.4458",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2693",
  "reporting-data": "static-1.68843",
  "cssUtils": "static-1.931",
  "flux-actions": "static-1.368",
  "react-colorpicker": "static-2.10527",
  "react-dnd-compat": "static-1.4927",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10680",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.684",
  "marketplace-ui-apps-core": "static-1.19278",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4818",
  "foundations-components-test-utils": "static-1.5988",
  "quartz-i18n": "static-1.1141",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.473",
  "ads-unified-auth-lib": "static-1.1431",
  "generic-oauth-auth-lib": "static-1.60",
  "google-sheets-integration-lib": "static-1.1042",
  "microsoft-drive-auth-lib": "static-1.156",
  "surveymonkey-integration-lib": "static-1.499",
  "slack-ui-library": "static-1.10709",
  "fsm": "static-1.4060",
  "customer-data-objects": "static-1.8002",
  "property-translator": "static-1.5705",
  "hs-locale-management": "static-1.299",
  "frontend-preferences-client": "static-1.8232",
  "hs-promise-utils": "static-1.5905",
  "hubspot-apollo-client": "static-1.5187",
  "integrations-error-boundary-lib": "static-1.14467",
  "integrations-tracking-lib": "static-1.5917",
  "native-integrations-shared-strings": "static-1.8087",
  "sanitize": "static-1.4782",
  "superstore": "static-1.5068",
  "ui-shepherd-react": "static-3.10580",
  "ai-settings-ui-library": "static-1.8360",
  "hub-http-janus": "static-1.880",
  "hubspotter-http": "static-1.4868",
  "immutable-less": "static-1.4960",
  "marketplace-ui-client-types": "static-1.18153",
  "nav-meta": "static-1.30480",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18395",
  "ui-product-approvals-common": "static-1.1087",
  "ai-studio-lib": "static-1.12447",
  "hubspot-prosemirror": "static-1.18981",
  "integrations-reconnect-lib": "static-1.494",
  "ui-addon-iframeable": "static-1.9388",
  "ui-addon-integrations-directory-panel": "static-2.8337",
  "ui-product-approvals": "static-1.29192",
  "ui-tool-access": "static-1.10464",
  "inbound-db-properties-service-client": "static-1.4059",
  "property-management-common": "static-1.6431",
  "opentelemetry-fe-types": "static-1.82",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.577",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.457",
  "quartz-auth": "static-1.1141",
  "quartz-test": "static-1.1141",
  "quartz-tracking": "static-1.845",
  "trellis-components": "static-1.2679",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.386",
  "HubStyle": "static-2.12106",
  "bender-build-tools": "static-1.3444",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23054",
  "ContentUtils": "static-1.69135",
  "customer-data-objects-ui-components": "static-1.13340",
  "sassPrefix": "static-1.202",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.443",
  "batch-promise": "static-1.1854",
  "event-emitter": "static-1.1263",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5762",
  "magpie-types": "static-1.5222",
  "stylex-utils": "static-1.141",
  "trellis-theming": "static-1.1284",
  "avatar-components": "static-1.2791",
  "breeze-engine-core": "static-1.1034",
  "breeze-onboarding-components": "static-1.748",
  "customer-data-filters-ui": "static-1.40942",
  "customer-data-reference-ui-components": "static-1.13487",
  "embedded-academy-lib": "static-1.15533",
  "ExportDialog": "static-6.10688",
  "global-styles-ai-lib": "static-1.151",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.631",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42060",
  "reporting-snowflake": "static-1.57460",
  "reporting-ui-components": "static-2.66113",
  "reporting-visualizations": "static-1.60918",
  "trial-components-library": "static-1.14116",
  "ui-addon-teams": "static-1.21916",
  "upgrade-components-lib": "static-1.530",
  "navigation-components": "static-1.18843",
  "breeze-engine-lib": "static-1.1756",
  "simple-logging-lib": "static-1.3361",
  "fail-safe": "static-1.263",
  "app-governance-lib": "static-1.2403",
  "developer-experience-shared-components": "static-1.10850",
  "purchase-motions-components": "static-1.6374",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10284",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4011",
  "reference-resolvers": "static-1.8491",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4228",
  "hubspot-apollo-cache": "static-1.646",
  "universal-page-editor-lib": "static-1.3318",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3535",
  "atom": "static-1.5396",
  "merchandise-lib": "static-1.278",
  "salesImages": "static-1.572",
  "ui-addon-draggable": "static-3.5070",
  "content-assistance-lib": "static-1.8208",
  "content-media-capture": "static-1.5453",
  "customer-data-ui-utilities": "static-1.10139",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24511",
  "growth-payments-core": "static-1.26194",
  "knowledge-content-types": "static-1.8653",
  "PatternValidationJS": "static-1.3203",
  "payment-link-components": "static-1.24182",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20314",
  "ui-addon-emoji-picker": "static-1.10196",
  "ui-business-units-lib": "static-1.9398",
  "video-components-external": "static-1.12158",
  "video-data-lib": "static-1.35816",
  "navigation-messaging": "static-1.8170",
  "collaboration-sidebar": "static-1.58733",
  "crm-component-utils": "static-1.39853",
  "crm-properties-common-lib": "static-1.6198",
  "customer-data-properties": "static-1.52621",
  "external-options-client-types": "static-1.4343",
  "framework-data-schema-resolvers": "static-1.7202",
  "property-value-citations": "static-1.3235",
  "reference-resolvers-lite": "static-1.8413",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10627",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5124",
  "content-icons-ui": "static-1.2373",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1028",
  "breeze-artifacts-sdk": "static-1.359",
  "onboarding-journeys-lib": "static-1.925",
  "onboarding-scopes": "static-1.6762",
  "conversations-skeleton-state": "static-1.7557",
  "crm-message-bus": "static-1.43779",
  "customer-data-filters-ui-msw-helpers": "static-1.23377",
  "events-data-lib": "static-1.555",
  "FormUrlGenerator": "static-2.5037",
  "framework-builder-read-service-client": "static-1.4225",
  "hs-resources": "static-1.501",
  "multi-account-reference-resolvers": "static-1.1315",
  "onboarding-tours": "static-1.17128",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14477",
  "academy-common-lib": "static-1.14993",
  "dashboard-lib": "static-1.82855",
  "getting-started-shared-tasks": "static-1.19252",
  "hubspot-prosemirror-plugins": "static-1.18973",
  "share-with-third-party-component-lib": "static-1.9017",
  "ui-asset-management-lib": "static-1.11408",
  "user-context": "static-1.5430",
  "reporting-plugins": "static-1.10765",
  "reporting-reports": "static-1.68520",
  "hubs-service-types": "static-1.1569",
  "purchase-motions-api": "static-1.6377",
  "signup-constants": "static-1.19639",
  "nest": "static-1.546",
  "breeze-engine-chat-components": "static-1.734",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.214",
  "framework-listing-lib": "static-2.29508",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31446",
  "apps-service-types": "static-1.4049",
  "oauth-service-types": "static-1.4548",
  "signup-ui-url-generator": "static-2.8371",
  "onboarding-tours-client": "static-1.5343",
  "one-click-checkout": "static-1.425",
  "platform-infra-nav-components": "static-1.7897",
  "subscription-experience-data-types": "static-1.15248",
  "crm-record-cards-service-types": "static-1.3791",
  "location-customization-utils-lib": "static-1.10111",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29320",
  "content-media-composition-data-lib": "static-1.13257",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4736",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.740",
  "ui-addon-opt": "static-4.8674",
  "commerce-tours-lib": "static-1.6626",
  "growth-onboarding-reliability": "static-1.5391",
  "sales-checkout-service-client": "static-1.3838",
  "data-token-picker": "static-1.16898",
  "FileManagerLib": "static-1.40151",
  "content-media-compositions": "static-2.17264",
  "media-bridge-lib": "static-1.19415",
  "chatspot-widget-iframe": "static-1.23045",
  "collaboration-sidebar-common": "static-1.3530",
  "marketing-platform-lib": "static-1.7180",
  "card-properties-lib": "static-1.45024",
  "commerce-subscription-lib": "static-1.37793",
  "crm-actions": "static-1.6662",
  "crm-cards-sdk": "static-1.44593",
  "customer-data-properties-shared-msw-handlers": "static-1.9956",
  "customer-data-tracking": "static-1.7192",
  "calling-global-api": "static-1.65642",
  "calling-internal-common": "static-1.31631",
  "calling-lifecycle-internal": "static-1.67024",
  "calling-lifecycle-messages": "static-1.59318",
  "commerce-products-lib": "static-1.10540",
  "conditional-properties-service-client": "static-1.4019",
  "crm-index-visualization-core": "static-1.4551",
  "crm-links": "static-1.6640",
  "crm-pipelines-api-client-types": "static-1.4352",
  "formula-editor": "static-1.14778",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4432",
  "meetings-icalendar-utils-lib": "static-1.946",
  "multi-currency-client-types": "static-1.3914",
  "object-builder-ui-client": "static-1.49690",
  "pipeline-validation-client-types": "static-1.4186",
  "smart-data-capture-core": "static-1.153",
  "smart-property-lib": "static-1.8310",
  "tiered-pricing": "static-1.1965",
  "topics-actions-lib": "static-1.476",
  "ui-addon-form-validation": "static-1.11292",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.321",
  "framework-data-schema-quick-fetch": "static-1.7107",
  "restore-request-side-panel-lib": "static-1.1689",
  "growth-data-modal": "static-1.5906",
  "growth-onboarding-confetti": "static-1.3371",
  "growth-onboarding-next-action-utils": "static-1.2700",
  "onboarding-tours-utils": "static-1.1195",
  "ui-shepherd-tracker": "static-1.7961",
  "academy-service-client": "static-1.3997",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40010",
  "SafeStorage": "static-1.4714",
  "video-embed": "static-1.36650",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.25011",
  "viral-links-lib": "static-1.7386",
  "nested-table": "static-1.543",
  "timezone-utils": "static-2.5554",
  "getting-started-shared-tasks-store": "static-1.18370",
  "campaign-roi-lib": "static-1.10283",
  "campaigns-utils-lib": "static-1.3528",
  "ui-addon-calendars": "static-2.5644",
  "customer-data-views-management": "static-1.26043",
  "framework-data-table": "static-2.12560",
  "nudge-client-utils": "static-1.3152",
  "nudge-custom-ui-functions": "static-1.1502",
  "switchboard-lib": "static-1.526",
  "access-check-ui-lib": "static-1.1596",
  "app-users-service-client": "static-1.5928",
  "app-users-service-types": "static-1.5336",
  "mini-checkout-client": "static-1.27520",
  "onboarding-utils": "static-1.5678",
  "permissions-shared-i18n-strings-fe": "static-1.2123",
  "ui-coaching-tips-shared-config": "static-1.29305",
  "checkout-sdk": "static-3.24363",
  "payment-method-components": "static-1.7161",
  "touchless-buying-components": "static-1.6231",
  "upgrade-catalog-service-types": "static-1.3780",
  "edison-service-client-types": "static-1.703",
  "growth-onboarding-feedback-components": "static-1.6894",
  "audio-components": "static-1.6353",
  "FileManagerImages": "static-1.37662",
  "video-components": "static-1.14160",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92844",
  "customer-data-sidebar": "static-2.46748",
  "enrichment-lib": "static-1.404",
  "ui-addon-draggable-compat": "static-2.4574",
  "universal-record-utils-lib": "static-1.1975",
  "commerce-billing-lib": "static-1.20199",
  "commerce-shared-components-lib": "static-1.19232",
  "commerce-tools-ui-lib": "static-1.11054",
  "crm-fe-perf": "static-1.23212",
  "calling-error-reporting": "static-1.31638",
  "shared-worker-versioning": "static-1.11352",
  "calling-usage-tracker": "static-1.6846",
  "voice-sms-access-library": "static-1.2074",
  "commerce-permissions": "static-1.1087",
  "products-iframe-lib": "static-1.8602",
  "products-ui-components-shared-msw-handlers": "static-1.11011",
  "crm-index-associations-lib": "static-1.6751",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10712",
  "sales-views-client-types": "static-1.4566",
  "bark-lib": "static-1.16822",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.658",
  "policy-lib": "static-1.7111",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10775",
  "onboarding-data-sync-lib": "static-1.2522",
  "growth-onboarding-next-action-components": "static-1.2728",
  "user-context-client": "static-1.4816",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4843",
  "outpost": "static-1.4464",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22166",
  "sales-email-signature-service-client": "static-1.4155",
  "ts-utils-lib": "static-1.459",
  "crm-export-dialog": "static-1.6593",
  "crm-index-ui-shimmer": "static-1.2660",
  "crm-view-components": "static-1.1180",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7636",
  "tasks-actions-lib": "static-1.143",
  "nudge-custom-function-registry": "static-1.2909",
  "nudge-renderer-utils": "static-1.3228",
  "whisper-core-api": "static-1.7338",
  "InboxConnectUtils": "static-4.15570",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46856",
  "hub-http-rxjs": "static-1.844",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4299",
  "company-details-components": "static-1.6513",
  "react-performance-metrics-lib": "static-1.865",
  "pricing-pages-ui-components": "static-1.15840",
  "quote-checkout-service-types": "static-1.3764",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22505",
  "customer-data-email": "static-1.18535",
  "card-payment-highlight-lib": "static-1.37993",
  "commerce-contract-lib": "static-1.13343",
  "invoices-highlight-card-lib": "static-1.55784",
  "orders-highlight-card-lib": "static-1.22206",
  "products-highlight-card-lib": "static-1.18823",
  "quotes-highlight-card-lib": "static-1.72846",
  "crm-source-interpretation-lib": "static-1.5640",
  "data-agent-utils": "static-1.466",
  "smart-property-fill-lib": "static-1.328",
  "crm-object-search-query-utilities": "static-1.10201",
  "utility-belt": "static-1.2842",
  "payments-enrollment-embed-lib": "static-1.23861",
  "stripe-embedded-components": "static-1.8007",
  "customer-data-rte": "static-1.33657",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6285",
  "payments-post-enroll-local-storage-lib": "static-1.5414",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38936",
  "calling-orchestration-schema": "static-1.36851",
  "react-reducer-toolkit": "static-1.16376",
  "meetings-connect-utils-lib": "static-1.7919",
  "hub-http-contrib": "static-1.3349",
  "ui-addon-sales-email": "static-1.5522",
  "access-control-lib": "static-1.10746",
  "EmailComponents": "static-1.55560",
  "EmailData": "static-1.54238",
  "redux-less": "static-2.9788",
  "company-details-service-types": "static-1.4249",
  "segments-query-core": "static-1.1734",
  "pricing-pages-api": "static-1.15705",
  "sequences-lib": "static-1.8540",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41058",
  "accounting-integrations-ui-components": "static-1.7546",
  "invoices-ui-lib": "static-1.55800",
  "commerce-products-api": "static-1.2701",
  "invoices-iframe-lib": "static-1.57858",
  "quotes-modal-lib": "static-1.103524",
  "quotes-ui-lib": "static-1.81567",
  "stripe-connect-js": "static-1.76",
  "draft-content-plugins": "static-1.28914",
  "ContentComponents": "static-2.72091",
  "ContentData": "static-1.69210",
  "marketing-contacts-lib": "static-1.11044",
  "marketing-email-service-types": "static-1.2101",
  "messaging-editing-lib": "static-1.47160",
  "messaging-usage-based-billing-components-lib": "static-1.2022",
  "automation-ui-source-apps": "static-1.19689",
  "automation-ui-types": "static-1.20607",
  "messaging-types-lib": "static-1.46897",
  "onboarding-settings-client": "static-1.4818",
  "sequences-client-types-lib": "static-1.8397",
  "commerce-tax-lib": "static-1.849",
  "price-books-api": "static-1.1746",
  "price-books-components": "static-1.1804",
  "property-description-translator": "static-1.4148",
  "ramp-editor": "static-1.899",
  "commerce-analytics-service-client": "static-1.3826",
  "totals-ui-components": "static-1.24303",
  "SalesContentIndexUI": "static-3.9632",
  "advanced-menus-core": "static-1.15585",
  "advanced-menus-lib": "static-1.12459",
  "automation-ui-ubb": "static-1.6523",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7647",
  "data-token-views": "static-1.16879",
  "forms-utils-lib": "static-1.13102",
  "payments-embed-points-lib": "static-1.13599",
  "react-tinymce": "static-1.55992",
  "simple-menus-core": "static-1.15584",
  "simple-menus-lib": "static-1.17101",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55118",
  "tinymce-data": "static-1.41203",
  "tinymce-plugins": "static-1.58232",
  "tinymce-themes": "static-1.57088",
  "ui-brand-identity-lib": "static-1.16505",
  "ui-memberships-settings-lib": "static-1.34856",
  "videoconference-integration-components": "static-1.7291",
  "marketing-contacts-client": "static-1.7819",
  "mc-hard-limits-client-types": "static-1.216",
  "automation-applications-service-types": "static-1.3652",
  "automation-platform-service-types": "static-1.2663",
  "ContentEditorUI": "static-2.77919",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4225",
  "web-interactives-components": "static-1.14257",
  "web-interactives-data": "static-1.14258",
  "messaging-shared-utils-lib": "static-1.1471",
  "messaging-user-info-utils-lib": "static-1.1641",
  "email-portal-health-service-types": "static-1.1289",
  "line-items-api": "static-1.1105",
  "commerce-totals-service-types": "static-1.4036",
  "FireAlarmUi": "static-1.4727",
  "sales-templates-service-types-lib": "static-1.4388",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22543",
  "automation-ui-usage-tracking": "static-1.22006",
  "data-studio-ubb": "static-1.3521",
  "interframe": "static-3.5065",
  "layout-dnd-components": "static-1.12978",
  "layout-dnd-utils": "static-1.11953",
  "NamespacedHubStyle": "static-2.9269",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27674",
  "content-management-data-lib": "static-1.5967",
  "copilot-plugins": "static-1.11828",
  "cta-picker": "static-1.37093",
  "customer-agent-discovery-components-lib": "static-1.3969",
  "editor-components": "static-1.13657",
  "editor-iframe-lib": "static-1.8806",
  "error-messaging-js": "static-1.5507",
  "FormsCommonComponents": "static-1.86570",
  "layout-data-lib": "static-1.10278",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10960",
  "SharedLegalStrings": "static-1.2056",
  "smart-content-core": "static-1.43183",
  "smart-content-lib": "static-1.43836",
  "social-composer-lib": "static-1.60313",
  "structured-content-lib": "static-1.25927",
  "theme-previewer-lib": "static-1.53949",
  "tinymce-copilot": "static-1.17186",
  "xray-recommendation-lib": "static-1.8269",
  "automation-ui-routing": "static-1.21964",
  "sql-reporting-client-types": "static-1.5903",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42800",
  "reporting-enablement": "static-1.23851",
  "forms-ai-lib": "static-1.4772",
  "codemirror-dlb": "static-1.59478",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6749",
  "report-customization-components": "static-1.13925",
  "data-quality-ui-library": "static-1.13822",
  "reporting-filters": "static-1.1015",
  "reporting-insights-lib": "static-1.2588",
  "merge-modal-lib": "static-1.12578",
  "segments-client-types": "static-1.11571"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13252",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.801",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9965",
  "foundations-components": "/foundations-components/static-1.8505",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1530",
  "foundations-theming": "/foundations-theming/static-1.4786",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8342",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10629",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11799",
  "I18n": "/I18n/static-7.1674",
  "jasmine-runner": "/jasmine-runner/static-1.6761",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.645",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13315",
  "quartz": "/quartz/static-1.7466",
  "react-dlb": "/react-dlb/static-1.89",
  "react-rhumb": "/react-rhumb/static-1.17032",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3166",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10776",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12835",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7637",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11457",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9845",
  "unified-auth": "/unified-auth/static-1.932",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1214",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8411",
  "hub-http": "/hub-http/static-1.6523",
  "integrations-lib": "/integrations-lib/static-1.17052",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20746",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.732",
  "property-management-iframe": "/property-management-iframe/static-1.14143",
  "quartz-config": "/quartz-config/static-1.1244",
  "quartz-core": "/quartz-core/static-1.6685",
  "quartz-routing": "/quartz-routing/static-1.896",
  "quick-fetch": "/quick-fetch/static-1.4134",
  "react": "/react/static-7.196",
  "rpc-client-utils": "/rpc-client-utils/static-1.4976",
  "ts-schema": "/ts-schema/static-1.4299",
  "ui-universal-auth": "/ui-universal-auth/static-1.9418",
  "UIComponents": "/UIComponents/static-3.8745",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3626",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3743",
  "quartz-webpack": "/quartz-webpack/static-1.3690",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.544",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9730",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5195",
  "pulse": "/pulse/static-1.940",
  "react-codemirror": "/react-codemirror/static-1.10950",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.621",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4774",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2502",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9734",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.71",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5561",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2660",
  "ui-fonts": "/ui-fonts/static-1.1061",
  "ui-images": "/ui-images/static-2.1250",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3269",
  "foundations-theming-base": "/foundations-theming-base/static-1.3771",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.798",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3453",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4623",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9013",
  "ai-rendering-library": "/ai-rendering-library/static-1.11108",
  "chirp-fetch": "/chirp-fetch/static-1.2204",
  "connections-embed-lib": "/connections-embed-lib/static-1.1521",
  "copilot-toolkit": "/copilot-toolkit/static-1.11856",
  "feedback-loader": "/feedback-loader/static-1.29821",
  "laboratory-lib": "/laboratory-lib/static-3.7462",
  "marketplace-embed": "/marketplace-embed/static-1.22928",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10641",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20701",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14916",
  "sanitize-text": "/sanitize-text/static-1.8465",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7205",
  "quartz-head": "/quartz-head/static-1.1131",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4966",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4458",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2693",
  "reporting-data": "/reporting-data/static-1.68843",
  "cssUtils": "/cssUtils/static-1.931",
  "flux-actions": "/flux-actions/static-1.368",
  "react-colorpicker": "/react-colorpicker/static-2.10527",
  "react-dnd-compat": "/react-dnd-compat/static-1.4927",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10680",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.684",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19278",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4818",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5988",
  "quartz-i18n": "/quartz-i18n/static-1.1141",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.473",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1431",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.60",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1042",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.156",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.499",
  "slack-ui-library": "/slack-ui-library/static-1.10709",
  "fsm": "/fsm/static-1.4060",
  "customer-data-objects": "/customer-data-objects/static-1.8002",
  "property-translator": "/property-translator/static-1.5705",
  "hs-locale-management": "/hs-locale-management/static-1.299",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8232",
  "hs-promise-utils": "/hs-promise-utils/static-1.5905",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5187",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14467",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5917",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8087",
  "sanitize": "/sanitize/static-1.4782",
  "superstore": "/superstore/static-1.5068",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10580",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8360",
  "hub-http-janus": "/hub-http-janus/static-1.880",
  "hubspotter-http": "/hubspotter-http/static-1.4868",
  "immutable-less": "/immutable-less/static-1.4960",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18153",
  "nav-meta": "/nav-meta/static-1.30480",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18395",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1087",
  "ai-studio-lib": "/ai-studio-lib/static-1.12447",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18981",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.494",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9388",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8337",
  "ui-product-approvals": "/ui-product-approvals/static-1.29192",
  "ui-tool-access": "/ui-tool-access/static-1.10464",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4059",
  "property-management-common": "/property-management-common/static-1.6431",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.82",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.577",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.457",
  "quartz-auth": "/quartz-auth/static-1.1141",
  "quartz-test": "/quartz-test/static-1.1141",
  "quartz-tracking": "/quartz-tracking/static-1.845",
  "trellis-components": "/trellis-components/static-1.2679",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.386",
  "HubStyle": "/HubStyle/static-2.12106",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23054",
  "ContentUtils": "/ContentUtils/static-1.69135",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13340",
  "sassPrefix": "/sassPrefix/static-1.202",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.443",
  "batch-promise": "/batch-promise/static-1.1854",
  "event-emitter": "/event-emitter/static-1.1263",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5762",
  "magpie-types": "/magpie-types/static-1.5222",
  "stylex-utils": "/stylex-utils/static-1.141",
  "trellis-theming": "/trellis-theming/static-1.1284",
  "avatar-components": "/avatar-components/static-1.2791",
  "breeze-engine-core": "/breeze-engine-core/static-1.1034",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.748",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40942",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13487",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15533",
  "ExportDialog": "/ExportDialog/static-6.10688",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.151",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.631",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42060",
  "reporting-snowflake": "/reporting-snowflake/static-1.57460",
  "reporting-ui-components": "/reporting-ui-components/static-2.66113",
  "reporting-visualizations": "/reporting-visualizations/static-1.60918",
  "trial-components-library": "/trial-components-library/static-1.14116",
  "ui-addon-teams": "/ui-addon-teams/static-1.21916",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.530",
  "navigation-components": "/navigation-components/static-1.18843",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1756",
  "simple-logging-lib": "/simple-logging-lib/static-1.3361",
  "fail-safe": "/fail-safe/static-1.263",
  "app-governance-lib": "/app-governance-lib/static-1.2403",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10850",
  "purchase-motions-components": "/purchase-motions-components/static-1.6374",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10284",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4011",
  "reference-resolvers": "/reference-resolvers/static-1.8491",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4228",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.646",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3318",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3535",
  "atom": "/atom/static-1.5396",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "salesImages": "/salesImages/static-1.572",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5070",
  "content-assistance-lib": "/content-assistance-lib/static-1.8208",
  "content-media-capture": "/content-media-capture/static-1.5453",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10139",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24511",
  "growth-payments-core": "/growth-payments-core/static-1.26194",
  "knowledge-content-types": "/knowledge-content-types/static-1.8653",
  "PatternValidationJS": "/PatternValidationJS/static-1.3203",
  "payment-link-components": "/payment-link-components/static-1.24182",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20314",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10196",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9398",
  "video-components-external": "/video-components-external/static-1.12158",
  "video-data-lib": "/video-data-lib/static-1.35816",
  "navigation-messaging": "/navigation-messaging/static-1.8170",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58733",
  "crm-component-utils": "/crm-component-utils/static-1.39853",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6198",
  "customer-data-properties": "/customer-data-properties/static-1.52621",
  "external-options-client-types": "/external-options-client-types/static-1.4343",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7202",
  "property-value-citations": "/property-value-citations/static-1.3235",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8413",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10627",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5124",
  "content-icons-ui": "/content-icons-ui/static-1.2373",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1028",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.359",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.925",
  "onboarding-scopes": "/onboarding-scopes/static-1.6762",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7557",
  "crm-message-bus": "/crm-message-bus/static-1.43779",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23377",
  "events-data-lib": "/events-data-lib/static-1.555",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5037",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4225",
  "hs-resources": "/hs-resources/static-1.501",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1315",
  "onboarding-tours": "/onboarding-tours/static-1.17128",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14477",
  "academy-common-lib": "/academy-common-lib/static-1.14993",
  "dashboard-lib": "/dashboard-lib/static-1.82855",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19252",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18973",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9017",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11408",
  "user-context": "/user-context/static-1.5430",
  "reporting-plugins": "/reporting-plugins/static-1.10765",
  "reporting-reports": "/reporting-reports/static-1.68520",
  "hubs-service-types": "/hubs-service-types/static-1.1569",
  "purchase-motions-api": "/purchase-motions-api/static-1.6377",
  "signup-constants": "/signup-constants/static-1.19639",
  "nest": "/nest/static-1.546",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.734",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.214",
  "framework-listing-lib": "/framework-listing-lib/static-2.29508",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31446",
  "apps-service-types": "/apps-service-types/static-1.4049",
  "oauth-service-types": "/oauth-service-types/static-1.4548",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8371",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5343",
  "one-click-checkout": "/one-click-checkout/static-1.425",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7897",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15248",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3791",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10111",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29320",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13257",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4736",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.740",
  "ui-addon-opt": "/ui-addon-opt/static-4.8674",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6626",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5391",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3838",
  "data-token-picker": "/data-token-picker/static-1.16898",
  "FileManagerLib": "/FileManagerLib/static-1.40151",
  "content-media-compositions": "/content-media-compositions/static-2.17264",
  "media-bridge-lib": "/media-bridge-lib/static-1.19415",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23045",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3530",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7180",
  "card-properties-lib": "/card-properties-lib/static-1.45024",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37793",
  "crm-actions": "/crm-actions/static-1.6662",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44593",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9956",
  "customer-data-tracking": "/customer-data-tracking/static-1.7192",
  "calling-global-api": "/calling-global-api/static-1.65642",
  "calling-internal-common": "/calling-internal-common/static-1.31631",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67024",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59318",
  "commerce-products-lib": "/commerce-products-lib/static-1.10540",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4019",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4551",
  "crm-links": "/crm-links/static-1.6640",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4352",
  "formula-editor": "/formula-editor/static-1.14778",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4432",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.946",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3914",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49690",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4186",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.153",
  "smart-property-lib": "/smart-property-lib/static-1.8310",
  "tiered-pricing": "/tiered-pricing/static-1.1965",
  "topics-actions-lib": "/topics-actions-lib/static-1.476",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11292",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.321",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7107",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1689",
  "growth-data-modal": "/growth-data-modal/static-1.5906",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3371",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2700",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1195",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7961",
  "academy-service-client": "/academy-service-client/static-1.3997",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40010",
  "SafeStorage": "/SafeStorage/static-1.4714",
  "video-embed": "/video-embed/static-1.36650",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25011",
  "viral-links-lib": "/viral-links-lib/static-1.7386",
  "nested-table": "/nested-table/static-1.543",
  "timezone-utils": "/timezone-utils/static-2.5554",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18370",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10283",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3528",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5644",
  "customer-data-views-management": "/customer-data-views-management/static-1.26043",
  "framework-data-table": "/framework-data-table/static-2.12560",
  "nudge-client-utils": "/nudge-client-utils/static-1.3152",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1502",
  "switchboard-lib": "/switchboard-lib/static-1.526",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1596",
  "app-users-service-client": "/app-users-service-client/static-1.5928",
  "app-users-service-types": "/app-users-service-types/static-1.5336",
  "mini-checkout-client": "/mini-checkout-client/static-1.27520",
  "onboarding-utils": "/onboarding-utils/static-1.5678",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2123",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29305",
  "checkout-sdk": "/checkout-sdk/static-3.24363",
  "payment-method-components": "/payment-method-components/static-1.7161",
  "touchless-buying-components": "/touchless-buying-components/static-1.6231",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3780",
  "edison-service-client-types": "/edison-service-client-types/static-1.703",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6894",
  "audio-components": "/audio-components/static-1.6353",
  "FileManagerImages": "/FileManagerImages/static-1.37662",
  "video-components": "/video-components/static-1.14160",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92844",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46748",
  "enrichment-lib": "/enrichment-lib/static-1.404",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4574",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1975",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20199",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19232",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11054",
  "crm-fe-perf": "/crm-fe-perf/static-1.23212",
  "calling-error-reporting": "/calling-error-reporting/static-1.31638",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11352",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6846",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2074",
  "commerce-permissions": "/commerce-permissions/static-1.1087",
  "products-iframe-lib": "/products-iframe-lib/static-1.8602",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11011",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6751",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10712",
  "sales-views-client-types": "/sales-views-client-types/static-1.4566",
  "bark-lib": "/bark-lib/static-1.16822",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.658",
  "policy-lib": "/policy-lib/static-1.7111",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10775",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2522",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2728",
  "user-context-client": "/user-context-client/static-1.4816",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4843",
  "outpost": "/outpost/static-1.4464",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22166",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4155",
  "ts-utils-lib": "/ts-utils-lib/static-1.459",
  "crm-export-dialog": "/crm-export-dialog/static-1.6593",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2660",
  "crm-view-components": "/crm-view-components/static-1.1180",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7636",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.143",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2909",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3228",
  "whisper-core-api": "/whisper-core-api/static-1.7338",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15570",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46856",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.844",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4299",
  "company-details-components": "/company-details-components/static-1.6513",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.865",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15840",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3764",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22505",
  "customer-data-email": "/customer-data-email/static-1.18535",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37993",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13343",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55784",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22206",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18823",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72846",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5640",
  "data-agent-utils": "/data-agent-utils/static-1.466",
  "smart-property-fill-lib": "/smart-property-fill-lib/static-1.328",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10201",
  "utility-belt": "/utility-belt/static-1.2842",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23861",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8007",
  "customer-data-rte": "/customer-data-rte/static-1.33657",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6285",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5414",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38936",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36851",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16376",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7919",
  "hub-http-contrib": "/hub-http-contrib/static-1.3349",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5522",
  "access-control-lib": "/access-control-lib/static-1.10746",
  "EmailComponents": "/EmailComponents/static-1.55560",
  "EmailData": "/EmailData/static-1.54238",
  "redux-less": "/redux-less/static-2.9788",
  "company-details-service-types": "/company-details-service-types/static-1.4249",
  "segments-query-core": "/segments-query-core/static-1.1734",
  "pricing-pages-api": "/pricing-pages-api/static-1.15705",
  "sequences-lib": "/sequences-lib/static-1.8540",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41058",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7546",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55800",
  "commerce-products-api": "/commerce-products-api/static-1.2701",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57858",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103524",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81567",
  "stripe-connect-js": "/stripe-connect-js/static-1.76",
  "draft-content-plugins": "/draft-content-plugins/static-1.28914",
  "ContentComponents": "/ContentComponents/static-2.72091",
  "ContentData": "/ContentData/static-1.69210",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.11044",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2101",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47160",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2022",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19689",
  "automation-ui-types": "/automation-ui-types/static-1.20607",
  "messaging-types-lib": "/messaging-types-lib/static-1.46897",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4818",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8397",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.849",
  "price-books-api": "/price-books-api/static-1.1746",
  "price-books-components": "/price-books-components/static-1.1804",
  "property-description-translator": "/property-description-translator/static-1.4148",
  "ramp-editor": "/ramp-editor/static-1.899",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3826",
  "totals-ui-components": "/totals-ui-components/static-1.24303",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9632",
  "advanced-menus-core": "/advanced-menus-core/static-1.15585",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12459",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6523",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7647",
  "data-token-views": "/data-token-views/static-1.16879",
  "forms-utils-lib": "/forms-utils-lib/static-1.13102",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13599",
  "react-tinymce": "/react-tinymce/static-1.55992",
  "simple-menus-core": "/simple-menus-core/static-1.15584",
  "simple-menus-lib": "/simple-menus-lib/static-1.17101",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55118",
  "tinymce-data": "/tinymce-data/static-1.41203",
  "tinymce-plugins": "/tinymce-plugins/static-1.58232",
  "tinymce-themes": "/tinymce-themes/static-1.57088",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16505",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34856",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7291",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7819",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.216",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3652",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
  "ContentEditorUI": "/ContentEditorUI/static-2.77919",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4225",
  "web-interactives-components": "/web-interactives-components/static-1.14257",
  "web-interactives-data": "/web-interactives-data/static-1.14258",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1471",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1641",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1289",
  "line-items-api": "/line-items-api/static-1.1105",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4036",
  "FireAlarmUi": "/FireAlarmUi/static-1.4727",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4388",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22543",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22006",
  "data-studio-ubb": "/data-studio-ubb/static-1.3521",
  "interframe": "/interframe/static-3.5065",
  "layout-dnd-components": "/layout-dnd-components/static-1.12978",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11953",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9269",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27674",
  "content-management-data-lib": "/content-management-data-lib/static-1.5967",
  "copilot-plugins": "/copilot-plugins/static-1.11828",
  "cta-picker": "/cta-picker/static-1.37093",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3969",
  "editor-components": "/editor-components/static-1.13657",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8806",
  "error-messaging-js": "/error-messaging-js/static-1.5507",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86570",
  "layout-data-lib": "/layout-data-lib/static-1.10278",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10960",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2056",
  "smart-content-core": "/smart-content-core/static-1.43183",
  "smart-content-lib": "/smart-content-lib/static-1.43836",
  "social-composer-lib": "/social-composer-lib/static-1.60313",
  "structured-content-lib": "/structured-content-lib/static-1.25927",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53949",
  "tinymce-copilot": "/tinymce-copilot/static-1.17186",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8269",
  "automation-ui-routing": "/automation-ui-routing/static-1.21964",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5903",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42800",
  "reporting-enablement": "/reporting-enablement/static-1.23851",
  "forms-ai-lib": "/forms-ai-lib/static-1.4772",
  "codemirror-dlb": "/codemirror-dlb/static-1.59478",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6749",
  "report-customization-components": "/report-customization-components/static-1.13925",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13822",
  "reporting-filters": "/reporting-filters/static-1.1015",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2588",
  "merge-modal-lib": "/merge-modal-lib/static-1.12578",
  "segments-client-types": "/segments-client-types/static-1.11571"
}
};
